module.exports = __webpack_public_path__ + "static/img/bgimg5-2.a530ad32.png";